export const caseStudiesData = [
  {
    slug: "jordi-sancho-author",
    clientName: "Jordi Sancho",
    category: "Author & Content",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/02bbb347e8f40e4510c290e995d906e0.jpg",
    en: {
      title: "Local author drives targeted traffic and lands a live bookstore reading.",
      challenge: "Jordi had a great new book, 'Mi Vecina Teresa', but zero traffic. He was a local writer struggling to get eyeballs in a noisy market.",
      solution: "We built a dedicated promo video to grab attention. Then, we created a streamlined link-in-bio page to capture that traffic and remove buying friction.",
      results: [
        "Drove 66 targeted clicks directly to the buying page.",
        "Secured immediate book purchases.",
        "Generated enough local noise to get invited for a live reading at a local bookstore."
      ]
    },
    es: {
      title: "Autor local genera tráfico cualificado y consigue una presentación en librería.",
      challenge: "Jordi tenía un excelente libro nuevo, 'Mi Vecina Teresa', pero tráfico cero. Era un escritor local luchando por visibilidad en un mercado saturado.",
      solution: "Creamos un video promocional específico para captar la atención. Luego, desarrollamos una página de 'link-in-bio' optimizada para capturar ese tráfico y eliminar la fricción de compra.",
      results: [
        "Generó 66 clics cualificados directos a la página de compra.",
        "Aseguró ventas inmediatas del libro.",
        "Generó suficiente impacto local para recibir una invitación para una lectura en vivo en una librería local."
      ]
    }
  },
  {
    slug: "favy-galindo-entertainer",
    clientName: "Favy Galindo",
    category: "Entertainment",
    image: "https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvcG5n/6eaa429ddf86ee9507f3dfd6f41a9209.png",
    en: {
      title: "Entertainer secures paid gigs and wins an industry award.",
      challenge: "Favy had an amazing show, 'Favy y Tonita', but a weak conversion mechanism. She had no professional hub to drive traffic to. This made it hard for prospects to actually book her.",
      solution: "We built a high-converting webpage with dedicated landing pages. We integrated a direct WhatsApp booking system. We removed all the friction so prospects could book with one click.",
      results: [
        "Secured multiple paid bookings directly through the new site.",
        "Built a polished brand presence that helped her win a multicultural award."
      ]
    },
    es: {
      title: "Artista asegura contrataciones pagadas y gana un premio del sector.",
      challenge: "Favy tenía un espectáculo increíble, 'Favy y Tonita', pero un mecanismo de conversión débil. Carecía de un hub profesional donde dirigir el tráfico, dificultando las reservas directas.",
      solution: "Construimos una web de alta conversión con páginas de aterrizaje específicas. Integramos un sistema de reservas directo vía WhatsApp, eliminando toda fricción para que los clientes pudieran reservar con un solo clic.",
      results: [
        "Aseguró múltiples contrataciones pagadas directamente a través del nuevo sitio.",
        "Construyó una presencia de marca profesional que le ayudó a ganar un premio multicultural."
      ]
    }
  },
  {
    slug: "notorious-fitness-club",
    clientName: "Notorious Fitness Club",
    website: "https://notoriousfc.com/",
    category: "Fitness & Content",
    image: "",
    en: {
      title: "Notorious Fitness Club reaches 30,000 targeted views and breaks through local obscurity.",
      challenge: "Notorious Fitness Club had a great functional training box in Barberà del Vallès, but zero traffic. They had the facility and the coaching, but strangers can only buy your stuff if they know you exist. They were a local gym struggling to get eyeballs in a noisy market.",
      solution: "We built a dedicated promo video to grab attention. Because advertising is simply the process of making your business known, we stripped away the fluff and focused the content on showcasing their raw training environment to stop the scroll. The goal was to get strangers to want their stuff by putting the gym's atmosphere front and center.",
      results: [
        "Drove 30,000 targeted views directly to their social media channels.",
        "Secured immediate local attention and brand awareness.",
        "Generated enough local noise to break through the obscurity, proving that if more people know about the stuff you sell, you sell more stuff."
      ]
    },
    es: {
      title: "Notorious Fitness Club alcanza 30.000 visualizaciones cualificadas y gana visibilidad local.",
      challenge: "Notorious Fitness Club tenía un excelente centro de entrenamiento funcional en Barberà del Vallès, pero no recibía tráfico. Tenían las instalaciones y los entrenadores, pero la gente solo puede comprar lo que ofreces si sabe que existes. Era un gimnasio local que luchaba por captar atención en un mercado saturado.",
      solution: "Creamos un vídeo promocional específico para captar la atención. Como la publicidad consiste, sencillamente, en dar a conocer un negocio, eliminamos lo superfluo y centramos el contenido en mostrar el ambiente real del entrenamiento para detener el scroll. El objetivo era despertar el interés de nuevos clientes poniendo en primer plano la energía del gimnasio.",
      results: [
        "Generó 30.000 visualizaciones cualificadas directamente en sus redes sociales.",
        "Consiguió atención local inmediata y reconocimiento de marca.",
        "Generó suficiente repercusión local para superar la falta de visibilidad y demostrar que, cuando más personas conocen lo que ofreces, vendes más."
      ]
    }
  }
];